import React from 'react';
import UbiWithdrawBottomSheet, {UbiWithdrawBottomSheetProps} from '@di-shared/features/ubi/UbiWithdrawBottomSheet';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import Environment from '@di-shared/features/environment/Environment';
import UbiWithdrawBottomSheetEu from '@di-shared/features/home/eu/benefit/UbiWithdrawBottomSheet.eu';
import UbiWithdrawBottomSheetNa from '@di-shared/features/home/na/benefit/UbiWithdrawBottomSheet.na';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 300;

function UbiWithdrawBottomPage() {
  const {vin, serviceId, agreeInfo} = (window as any).data as UbiWithdrawBottomSheetProps;

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <>
        <Environment.Kr>
          <UbiWithdrawBottomSheet
            vin={vin}
            serviceId={serviceId}
            agreeInfo={agreeInfo}
          />
        </Environment.Kr>
        <Environment.Eu>
          <UbiWithdrawBottomSheetEu />
        </Environment.Eu>
        <Environment.Na>
          <UbiWithdrawBottomSheetNa />
        </Environment.Na>
      </>
    </BottomSheetWebViewWrapper>
  );
}

export default UbiWithdrawBottomPage;
